var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { styled, css } from 'styled-components';
import { DoubleArrow, HighestToLowest, LowestToHighest } from '@hn-ui/icons';
export var ScTh = styled.th.withConfig({ displayName: "ScTh", componentId: "sc-v87xvp" })(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  position: relative;\n  user-select: none;\n  text-align: left;\n  font-weight: 700;\n  font-size: 10px;\n  line-height: 16px;\n  text-transform: uppercase;\n\n  ", "\n"], ["\n  position: relative;\n  user-select: none;\n  text-align: left;\n  font-weight: 700;\n  font-size: 10px;\n  line-height: 16px;\n  text-transform: uppercase;\n\n  ", "\n"])), function (_a) {
    var theme = _a.theme, isSorted = _a.isSorted;
    return isSorted
        ? css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n          color: ", ";\n        "], ["\n          color: ", ";\n        "])), theme.colors.blue50) : '';
});
var ScWrapper = styled.div.withConfig({ displayName: "ScWrapper", componentId: "sc-55hy2i" })(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  display: inline-flex;\n  align-items: flex-end;\n  justify-content: flex-start;\n"], ["\n  display: inline-flex;\n  align-items: flex-end;\n  justify-content: flex-start;\n"])));
var ScIcon = styled.span.withConfig({ displayName: "ScIcon", componentId: "sc-1gd2ewq" })(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  margin-left: 4px;\n"], ["\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  margin-left: 4px;\n"])));
var SortIcon = function (_a) {
    var direction = _a.direction;
    return direction === 'asc' ? (_jsx(LowestToHighest, { size: 16, color: 'blue50' }, void 0)) : (_jsx(HighestToLowest, { size: 16, color: 'blue50' }, void 0));
};
function TableHeaderCell(_a) {
    var _b = _a.column, canSort = _b.canSort, isSorted = _b.isSorted, isSortedDesc = _b.isSortedDesc, render = _b.render, className = _a.className, props = __rest(_a, ["column", "className"]);
    return (_jsx(ScTh, __assign({}, props, { isSorted: isSorted, className: className }, { children: canSort ? (_jsxs(ScWrapper, { children: [render('Header'), _jsx(ScIcon, { children: isSorted ? (_jsx(SortIcon, { direction: isSortedDesc ? 'desc' : 'asc' }, void 0)) : (_jsx(DoubleArrow, { size: 16, color: 'black10' }, void 0)) }, void 0)] }, void 0)) : (render('Header')) }), void 0));
}
export default TableHeaderCell;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
